import { Component } from "preact";
import { connectWithTranslations } from "../../../../common/helpers/translationsHelpers";
import { CATEGORY_FILTER_OPTIONS, GTM_ID, GA4EVENT } from "../../../constants";
import CheckboxPicker from "../../../../common/components/CheckboxPicker";
import IconCaretDown from "../../../../common/components/icons/IconCaretDown";
class AdvancedCategoryFilterMobile extends Component {
    constructor(props) {
        super(props);

        this.togglePicker = this.togglePicker.bind(this);
        this.applyNewSelectedCategories =
            this.applyNewSelectedCategories.bind(this);

        this.state = {
            isPickerOpen: false,
            selected: [],
        };
    }
    componentWillMount() {
        const categories = getKeysOfNotNullValues(CATEGORY_FILTER_OPTIONS);

        this.setState({
            selected: this.props.selectedCategories,
            categories,
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.selectedCategories !== nextProps.selectedCategories) {
            const selected = this.state.categories.filter((key) =>
                nextProps.selectedCategories.includes(
                    CATEGORY_FILTER_OPTIONS[key]
                )
            );
            this.setState({
                selected: selected.map((x) => CATEGORY_FILTER_OPTIONS[x]),
            });
        }
    }

    onChangeCountriesSelected(newSelected) {
        this.setState({
            selected: newSelected,
        });
    }

    togglePicker() {
        if (this.state.isPickerOpen)
            this.setState({
                isPickerOpen: false,
                selected: this.props.selectedCategories,
            });
        else this.setState({ isPickerOpen: true });
    }

    applyNewSelectedCategories() {
        this.props.onChange(this.state.selected);
        this.togglePicker();
    }
    render({ onChange, translate, config }, { selected, categories }) {
        const selectedCatagories = getCategoriesSelected(categories, selected);
        return (
            <div>
                <h4 class="fxs_headline_small fxs_marginBase_top">
                    {this.props.translate("CategoryFilterTitle")}
                </h4>
                <button
                    type="button"
                    onClick={this.togglePicker}
                    class="fxs_c_filter_picker_trigger_button"
                >
                    {translate("CategoryFilterTitle")} ({selected.length})
                    <IconCaretDown />
                </button>
                {this.state.isPickerOpen && (
                    <div
                        class="fxs_c_advanced-countries-backdrop"
                        onClick={() => this.togglePicker()}
                    ></div>
                )}
                {this.state.isPickerOpen && (
                    <div class="fxs_c_filters_picker">
                        <h4 class="fxs_headline_tiny fxs_marginBase_bottom">Select category:</h4>
                        <CheckboxPicker
                            containerClass="fxs_c_category_picker_inner"
                            onChange={(values) =>
                                this.onChangeCountriesSelected(
                                    values.map(
                                        (x) => CATEGORY_FILTER_OPTIONS[x]
                                    )
                                )
                            }
                            renderTitle={() => { }}
                            values={categories}
                            checkedValues={selectedCatagories}
                            renderValue={(value) => (
                                <span>{translate(value)}</span>
                            )}
                            getOptionGtmId={(key) =>
                                config.tracking &&
                                GTM_ID.ADVANCED_FILTERS_CATEGORY_CHECKBOX(
                                    key
                                        .replace("Category_", "")
                                        .toLowerCase()
                                )
                            }
                            getOptionGA4Id={(key) =>
                                config.tracking &&
                                GA4EVENT.ELEMENTS.ADVANCED_FILTERS_CATEGORY_CHECKBOX(
                                    key
                                        .replace("Category_", "")
                                        .toLowerCase()
                                )}
                            getGa4Name={
                                config.tracking &&
                                GA4EVENT.NAMES.FEATURES_CALENDAR
                            }


                            labelClass="fxs_c_filter_picker_label"
                        />
                        <div class="fxs_c_filter_picker_footer">
                            <button
                                type="button"
                                onClick={() => this.togglePicker()}
                                class="fxs_btn fxs_btn_phantom fxs_fLeft"
                            >
                                {" "}
                                {this.props.translate("FilterCancelLabel")}
                            </button>
                            <button
                                type="button"
                                onClick={() =>
                                    this.applyNewSelectedCategories(selected)
                                }
                                class="fxs_btn fxs_btn_cta fxs_fRight"
                            >
                                {" "}
                                {this.props.translate("FilterDoneLabel")}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
const getCategoriesSelected = (categories, selected) =>
    selected.length === 0
        ? []
        : categories.filter((key) =>
            selected.includes(CATEGORY_FILTER_OPTIONS[key])
        );
const getKeysOfNotNullValues = (obj) =>
    Object.keys(obj).filter((k) => obj[k] !== null);

export default connectWithTranslations("config")(AdvancedCategoryFilterMobile);
